import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCsv } from '@fortawesome/free-solid-svg-icons'

function FiltersAddBarOrders(props) {
  return (
    <div className="filters-add-row">
      <div className="filters-add-col">
        <div className="filter-box">
          <input
            type="text"
            placeholder="Cerca..."
            value={props.search}
            onChange={e => props.setSearch(e.target.value)}
          />
        </div>
        <div className="filter-box">
          <label htmlFor="stato">Stato: </label>

          <select
            name="stato"
            id="stato"
            value={props.filterParams.filter}
            onChange={e =>
              props.setFilterParams({
                ...props.filterParams,
                filter: e.target.value,
              })
            }
          >
            {props.filterOptions.map((el, key) => (
              <option key={key} value={el.value}>
                {el.label}
              </option>
            ))}
          </select>
        </div>
        {props.showCancelledOptions ? (
          <div className="filter-box">
            <label htmlFor="cancellazione">Cancellazione: </label>
            <select
              name="cancellazione"
              id="cancellazione"
              value={props.filterParams.showCancelled || 'active'}
              onChange={e =>
                props.setFilterParams({
                  ...props.filterParams,
                  showCancelled: e.target.value,
                })
              }
            >
              {props.showCancelledOptions.map((el, key) => (
                <option key={key} value={el.value}>
                  {el.label}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        {props.filterParams.filter === 'range' ? (
          <>
            <div className="filter-box">
              <label htmlFor="stato">Inizio: </label>

              <input
                type="date"
                value={getTrimmedDate(props.filterParams.start)}
                onChange={e =>
                  props.setFilterParams({
                    ...props.filterParams,
                    start: new Date(e.target.value),
                  })
                }
              />
            </div>
            <div className="filter-box">
              <label htmlFor="stato">Fine: </label>
              <input
                type="date"
                value={getTrimmedDate(props.filterParams.end)}
                onChange={e =>
                  props.setFilterParams({
                    ...props.filterParams,
                    end: new Date(e.target.value),
                  })
                }
              />
            </div>
          </>
        ) : null}
      </div>
      <div className="filters-add-col">
        <button
          type="button"
          className="card-button card-button-primary"
          onClick={() => props.downloadBtn && props.downloadBtn()}
          title="Scarica gli ordini filtrati in formato CSV"
        >
          <FontAwesomeIcon icon={faFileCsv} /> Esporta CSV
        </button>
      </div>
    </div>
  )
}

function getTrimmedDate(date) {
  let date1 = new Date(date)
  let month = date1.getMonth() + 1
  return `${date1.getFullYear()}-${month > 9 ? month : '0' + month}-${
    date1.getDate() > 9 ? date1.getDate() : '0' + date1.getDate()
  }`
}

export default FiltersAddBarOrders
